import {
  combineReducers,
} from 'redux';
import {
  IStrictReducerMap,
} from '../Utils';
import feasibility from './feasibility/reducer';
import countryCountryProductYearByCountryCountry from './fetchedData/countryCountryProductYearByCountryCountry';
import countryCountryProductYearByCountryProduct from './fetchedData/countryCountryProductYearByCountryProduct';
import countryCountryYearByCountry from './fetchedData/countryCountryYearByCountry';
import countryLevelMapping from './fetchedData/countryLevelMapping';
import groupsMetadata from './fetchedData/groupsMetadata';
import groupMembersMetadata from './fetchedData/groupMembersMetadata';
import countryMetadata from './fetchedData/countryMetadata';
import countryProductYearByCountry from './fetchedData/countryProductYearByCountry';
import countryProductYearByProduct from './fetchedData/countryProductYearByProduct';
import countryYear from './fetchedData/countryYear';
import productSpaceLayout from './fetchedData/layoutData';
import productLevelMapping from './fetchedData/productLevelMapping';
import productMetadata from './fetchedData/productMetadata';
import productYear from './fetchedData/productYear';
import yearly from './fetchedData/yearlyData';
import geo from './geo/reducer';
import network from './network/reducer';
import rings from './rings/reducer';
import stack from './stack/reducer';
import {
  IWorkerRootState,
} from './workerRootState';

const reducersMap: IStrictReducerMap<IWorkerRootState> = {
  countryProductYearByCountry,
  countryProductYearByProduct,
  countryCountryYearByCountry,
  countryCountryProductYearByCountryCountry,
  countryCountryProductYearByCountryProduct,
  countryLevelMapping,
  countryYear,
  countryMetadata,
  groupsMetadata,
  groupMembersMetadata,
  productMetadata,
  productYear,
  yearly,
  rings,
  stack,
  productLevelMapping,
  productSpaceLayout,
  network,
  feasibility,
  geo,
};

const reducers = combineReducers<IWorkerRootState>(reducersMap);
export default reducers;
